// @flow

export default function isPageLoadedInsideIframe(): boolean {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}


// WEBPACK FOOTER //
// ./src/lib/isPageLoadedInsideIframe.js